import React, { useState } from "react";
import {
  Card,
  Tag,
  Empty,
  Row,
  Col,
  Modal,
  Avatar,
  Button,
  notification,
} from "antd";
import CustomerAddressForm from "./CustomerAddressForm";
import { postRequest } from "services/EndPointApiService";

const darkCardStyle = {
  borderRadius: 12,
  background: "#1f1f1f",
  color: "#fff",
  border: "1px solid #333",
  marginBottom: 16,
};

const levelMapping = {
  0: { label: "NEWLY JOINED", color: "blue" },
  1: { label: "CUSTOMER", color: "green" },
  2: { label: "MEMBER", color: "cyan" },
  3: { label: "MEMBER PLUS", color: "purple" },
  4: { label: "EKSKLUSIF MEMBER", color: "gold" },
  6: { label: "BLACKLIST", color: "red" },
  7: { label: "SUPER BLACKLIST", color: "volcano" },
};

const CustomerProfileSection = ({ customers }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const handleOpenForm = (customer) => {
    setSelectedCustomer(customer);
    setIsModalOpen(true);
  };

  const handleFinish = (values) => {
    postRequest("CustomerAdress/SaveCustomer", values).then((res) => {
      console.log("result Save", res);
    });

    notification.success({
      message: "Input Alamat Customer",
      description: "Update Customer Berhasil",
    });
    setIsModalOpen(false);
  };

  if (!customers || customers.length === 0) {
    return (
      <Card style={darkCardStyle} bordered={false}>
        <Empty
          description={
            <span style={{ color: "#fff" }}>Data customer tidak ditemukan</span>
          }
        />
      </Card>
    );
  }

  return (
    <Row gutter={[16, 16]}>
      {customers.map((cust, key) => {
        const level = levelMapping[cust.CustomerLevel] || {
          label: "UNKNOWN",
          color: "default",
        };

        return (
          <Col xs={24} sm={20} md={16} key={key}>
            <Card style={darkCardStyle} bordered={false}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <Avatar
                    size={56}
                    src={`https://graph.facebook.com/${cust.Fbid}/picture?type=large`}
                  />
                  <div>
                    <div style={{ fontSize: 16, fontWeight: "bold" }}>
                      {cust.FbName}
                    </div>
                    <Tag color={level.color}>{level.label}</Tag>
                  </div>
                </div>
                <Button type="primary" onClick={() => handleOpenForm(cust)}>
                  Update Alamat
                </Button>
              </div>

              <div style={{ marginTop: 12, fontSize: 13, color: "#ccc" }}>
                📞 {cust.NoHp} <br />
                🏠 {cust.RecipientAddress}, {cust.SubDistrict}, {cust.District},{" "}
                {cust.City}, {cust.Province}
              </div>

              <div
                style={{
                  marginTop: 12,
                  fontSize: 13,
                  color: "#aaa",
                  fontStyle: "italic",
                }}
              >
                Total Transaksi: {cust.TotalTransaction} | Valid:{" "}
                {cust.TotalValidTransaction}
              </div>

              <div style={{ fontSize: 12, color: "#777", marginTop: 4 }}>
                Last Maintain:{" "}
                {new Date(cust.LastMaintainDate).toLocaleDateString("id-ID")}
              </div>
            </Card>
            <Modal
              destroyOnClose
              className="chatwoot-address"
              title="Alamat Pengiriman"
              open={isModalOpen}
              onCancel={() => setIsModalOpen(false)}
              footer={null}
            >
              <CustomerAddressForm
                onFinish={handleFinish}
                initialValues={{
                  recipientName:
                    selectedCustomer?.RecipientName ||
                    selectedCustomer?.FbName ||
                    "",
                  recipientAddress: selectedCustomer?.RecipientAddress || "",
                  noHp: selectedCustomer?.NoHp || "",
                  province: selectedCustomer?.Province || "",
                  city: selectedCustomer?.City || "",
                  district: selectedCustomer?.District || "",
                  subdistrict: selectedCustomer?.SubDistrict || "",
                }}
              />
            </Modal>
          </Col>
        );
      })}
    </Row>
  );
};

export default CustomerProfileSection;
